<script>
export default {
  props: {
    // The items to display
    items: {
      type: Array,
      requred: true,
    },

    // Whether to limit the list
    etc: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // Whether the list is expanded (only applicable if `etc` is true)
      expanded: false,
    };
  },
};
</script>

<template>
  <span>
    <span v-for="(item, index) in items" :key="index">
      <span v-if="expanded || !etc || items.length <= 3 || index < 2">
        <slot :item="item" />
        <span v-if="index < items.length - 1 && items.length != 2">,</span>
        <span v-if="index == 0 && items.length == 2">&nbsp;</span>
        <span v-if="index == items.length - 2">and</span>
      </span>
      <span v-if="items.length > 3 && index == 2 && etc && !expanded">
        and
        <b-link @click="expanded = true">{{ items.length - 2 }} others</b-link>
      </span>
    </span>
  </span>
</template>

<style></style>
